<template>
  <div class="max-w-md mx-auto">
    <div class="card">
      <h1 class="text-xl font-semibold mb-4">เข้าสู่ระบบแอดมิน</h1>
      <div class="space-y-3">
        <div>
          <input class="input" v-model="user.username" placeholder="ชื่อผู้ใช้" />
        </div>
        <div>
          <input class="input" type="password" v-model="user.password" placeholder="รหัสผ่าน" />
        </div>
        <button class="btn-primary w-full" @click="onSubmit">เข้าสู่ระบบ</button>
        <div v-if="error" class="text-sm text-red-600">{{ error }}</div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue'
import { useRouter } from 'vue-router'
import { useAuth } from '../../stores/auth'

const router = useRouter()
const auth = useAuth()

const user = ref({
  username: '',
  password: ''
})
const error = ref('')

async function onSubmit() {
  error.value = ''
  const ok = await auth.login(user.value.username, user.value.password)
  if (ok) {
    router.push('/admin/dashboard')
  } else {
    error.value = 'เข้าสู่ระบบไม่สำเร็จ'
  }
}
</script>
